import 'Plugins/popupPlugin';

// popups init
export default function initPopups() {
	jQuery('.aside-popup-holder').contentPopup({
		mode: 'click',
		popup: '.aside-filter-popup',
		btnOpen: '.aside-filter-opener'
	});
}